// @flow
import React, { type ComponentType, PureComponent } from 'react';
import AppUpsellHero from 'app/common/react/components/growth/activation/AppUpsellHero/AppUpsellHero';
import CreatorChecklistHero from 'app/common/react/components/CreatorChecklist/CreatorChecklistHero';
import CuratorUpsellHero from 'app/common/react/components/HomefeedCurator/CuratorUpsellHero';
import Experience from 'app/common/react/components/experiences/Experience/Experience';
import GenderSignalHero from 'app/common/react/components/growth/activation/GenderSignalHero/GenderSignalHero';
import Hero from 'app/common/react/ui/Hero';
import HomefeedInterestUpsellHero from 'app/common/react/components/growth/activation/HomefeedInterestUpsellHero/HomefeedInterestUpsellHero';
import LeadGenHero from 'app/common/react/components/partner/experiences/InAppLeadGenHero/InAppLeadGenHero';
import NonClosableHero from 'app/common/react/components/growth/activation/NonClosableHero/NonClosableHero';
import NuxChecklist from 'app/common/react/components/growth/activation/NuxChecklist';
import SocialConnectUpsellHero from 'app/common/react/components/growth/unauth/signup/SocialConnectUpsellHero/SocialConnectUpsellHero';
import toCamelCase from 'app/common/lib/util/toCamelCase';
import TopicEducation from 'app/common/react/components/growth/activation/TopicEducation/TopicEducation';
import WelcomeHero from 'app/common/react/components/growth/activation/WelcomeHero/WelcomeHero';
import { CSSTransition } from 'react-transition-group';
import { deepMapStringKeys } from 'app/common/lib/util/ObjectUtils';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';

type Props = {|
  placementId: number,
  requestContext: RequestContextType,
  completeButtonUrl?: string,
  onDismiss?: ?() => void,
|};

type State = {| animateIn: boolean |};

const TRANSITION_DURATION = 400;

export class ExperienceHero extends PureComponent<Props, State> {
  state = {
    animateIn: false,
  };

  getHeroClass(experience_id: number): ComponentType<any> {
    switch (experience_id) {
      case PCONST.thrift.Experience.WEB_APP_UPSELL_HERO:
      case PCONST.thrift.Experience.WEB_APP_UPSELL_SEARCH:
      case PCONST.thrift.Experience.WEB_APP_UPSELL_LANDING:
      case PCONST.thrift.Experience.WEB_APP_UPSELL_HERO_MIDS:
        return AppUpsellHero;
      case 500385:
        // TODO(kiwi@): temp: When the Thrift is published remove this line and uncomment below
        // PCONST.thrift.Experience.ADGRO_LEAD_GEN_HERO,
        return LeadGenHero;
      case PCONST.thrift.Experience.WEB_FIRST_LOGIN_SOCIAL_CONNECT_UPSELL:
        return SocialConnectUpsellHero;
      case PCONST.thrift.Experience.ATT_DAY_0_CHECKLIST_V2:
        return NuxChecklist;
      case PCONST.thrift.Experience.WEB_GENDER_SIGNAL_HERO:
        return GenderSignalHero;
      case PCONST.thrift.Experience.WEB_HOME_FEED_CURATOR_UPSELL_BANNER:
        return CuratorUpsellHero;
      case PCONST.thrift.Experience.HOMEFEED_INTEREST_UPSELL_HERO_REZ:
        return HomefeedInterestUpsellHero;
      case PCONST.thrift.Experience.WEB_WELCOME_HERO:
        return WelcomeHero;
      case PCONST.thrift.Experience.ATT_TOPIC_EDUCATION:
        return TopicEducation;
      case PCONST.thrift.Experience.WEB_CREATOR_CHECKLIST_HERO:
        return CreatorChecklistHero;
      case PCONST.thrift.Experience.WEB_ADS_CREDIT_HOMEFEED_REMINDER:
      case PCONST.thrift.Experience.WEB_PIN_STATS_USER_ED_BANNER:
        return NonClosableHero;
      default:
        return Hero;
    }
  }

  startTransition = () => {
    const { animateIn } = this.state;
    if (!animateIn) {
      this.setState({ animateIn: true });
    }
  };

  render() {
    const { placementId, requestContext, completeButtonUrl, onDismiss } = this.props;
    const { animateIn } = this.state;
    return (
      <Experience placementId={placementId} type={PCONST.thrift.ExperienceType.HERO}>
        {({ experience_id, complete, dismiss, display_data }) => {
          if (completeButtonUrl) {
            display_data.complete_button_url = completeButtonUrl;
          }
          const HeroComponent = this.getHeroClass(experience_id);
          const heroProps = {
            ...deepMapStringKeys(toCamelCase)(display_data),
            requestContext,
            experienceId: experience_id,
            handleComplete: complete,
            handleDismiss: () => {
              if (onDismiss) {
                onDismiss();
              }
              dismiss();
            },
            color: 'blue',
          };
          this.startTransition();
          return (
            <CSSTransition
              in={animateIn}
              timeout={TRANSITION_DURATION}
              classNames="ExperienceHero"
              unmountOnExit
            >
              <HeroComponent {...heroProps} />
            </CSSTransition>
          );
        }}
      </Experience>
    );
  }
}

export default withRequestContext(ExperienceHero);
